var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { get } from "lodash";
export default function getDataFromError(err, traceId, errorCode) {
    var data = err.data || // simple assign
        err.errorData || // already assigned
        get(err, "response.data.data") || // REST API response
        get(err, "data.errors[0].errorData") || // apollo client raw error
        get(err, "data.response.errors[0].errorData") || // apollo client error
        {};
    return __assign(__assign({}, data), { errorCode: "(Code: " + errorCode + ")", traceId: "(TraceId: " + traceId + ")" });
}
